// extracted by mini-css-extract-plugin
module.exports = {"root":"StaticReviews_root__LzyPb","title":"StaticReviews_title__oXviC"};